﻿import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function LoginPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (user) {
      if (user.mustChangePassword) {
        navigate('/alterar-senha', { replace: true });
        return;
      }

      navigate(user.perfil === 'admin' ? '/admin/dashboard' : '/colaborador', { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const result = await login(email, password);
    setIsLoading(false);

    if (!result.success) {
      setError(result.error || 'Erro ao fazer login.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-portal-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/assets/zschimmer-schwarz-logo-login.png"
            alt="Zschimmer & Schwarz Brasil"
            className="h-36 sm:h-44 w-auto object-contain mx-auto mb-5"
          />
          <h1 className="text-2xl font-bold text-portal-gray-900">
            Portal do Colaborador
          </h1>
          <p className="text-sm text-portal-gray-500 mt-1">
            Segurança do Trabalho
          </p>
        </div>

        <div className="bg-white rounded-xl border border-portal-gray-200 p-8 shadow-sm">
          <h2 className="text-lg font-semibold text-portal-gray-800 mb-6">
            Acesse sua conta
          </h2>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="email" className="block text-sm font-medium text-portal-gray-700 mb-1.5">
                E-mail
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Digite seu e-mail"
                className="w-full px-3.5 py-2.5 border border-portal-gray-300 rounded-lg text-sm text-portal-gray-800 placeholder-portal-gray-400 focus:outline-none focus:ring-2 focus:ring-portal-purple/20 focus:border-portal-purple transition-colors"
                autoComplete="email"
                required
              />
            </div>

            <div className="mb-6">
              <label htmlFor="password" className="block text-sm font-medium text-portal-gray-700 mb-1.5">
                Senha
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Digite sua senha"
                className="w-full px-3.5 py-2.5 border border-portal-gray-300 rounded-lg text-sm text-portal-gray-800 placeholder-portal-gray-400 focus:outline-none focus:ring-2 focus:ring-portal-purple/20 focus:border-portal-purple transition-colors"
                autoComplete="current-password"
                required
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-portal-purple hover:bg-portal-purple-dark text-white font-medium py-2.5 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
            >
              {isLoading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>

          <div className="mt-4 text-center">
            <p className="text-sm text-portal-gray-500">
              Não tem uma conta?{' '}
              <a
                href="/cadastro"
                className="text-portal-purple hover:text-portal-purple-dark font-medium transition-colors"
              >
                Autoinscrição
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
